import dayjs from "dayjs";
import _, { get, isEmpty } from "lodash";
import qs from "qs";
import { v4 as uuidv4 } from "uuid";
import md5 from "md5";

import {
  getConfigs,
  getPackage,
  checkRedeemCode,
  getCommission,
  createInsu,
  getBalance,
  getProductLines,
  scanImage,
  getProductLineByBikeType,
  uploadImg,
  scanImageV2,
  getStime
} from "../../controller/api_zuttoride";
import moment from "moment";
import { capitalizeWords, getParamUrlByKey, sortObjectByKey } from "../utils";

import { removeUnicode } from "../utils";

export default function zuttorideReducer({
  state,
  dispatch,
  action,
  platform,
  reward,
}) {
  const isApp = platform === "app";
  const isZalo_mini = platform === "zalo_mini";
  const cases = {
    initial: async () => {
      const validFrom = moment().add(1, "day");
      const validUntil = validFrom.clone().add(1, "year").add(-1, "day");
      return {
        vehicleInfo: {
          ...state.vehicleInfo,
          yearsOfInsurance: 1
        },
        insuranceInfo: {
          ...state.insuranceInfo,
          validFrom: validFrom.format("YYYY-MM-DD"),
          validUntil: validUntil.format("YYYY-MM-DD"),
        },
      };
    },

    validatePage: () => {
      const {
        vehicleInfo, insuranceInfo, dialogBill,
        haveBill, currentStep, errors, foundPackage, snackbars, invalidAppliedCommissionAmt
      } = state;
      let newSnackBars = { ...snackbars };
      const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const requireField = (condition, field, errors) => {
        if (!condition) {
          if (!errors.includes(field)) {
            errors.push(field);
          }
        } else {
          const index = errors.indexOf(field);
          if (index !== -1) {
            errors.splice(index, 1);
          }
        }
      };

      const minLength = (condition, min, field, errors) => {
        if (condition && condition.length < min) errors.push(field);
      };

      switch (currentStep) {
        case 1:
          if (!errors.step1) {
            errors.step1 = [];
          }
          requireField(vehicleInfo?.type?.id, "type", errors.step1);
          requireField(vehicleInfo?.brand?.id, "brand", errors.step1);
          requireField(vehicleInfo?.productLine?.id, "productLine", errors.step1);
          requireField(vehicleInfo?.period, "period", errors.step1);
          requireField(foundPackage && Object.keys(foundPackage).length > 0, "packageNotFound", errors.step1);

          break;
        case 2:
          if (!errors.step2) {
            errors.step2 = [];
          }
          requireField(insuranceInfo?.buyerName, "buyerName", errors.step2);
          minLength(insuranceInfo?.buyerName, 5, "buyerName_length", errors.step2);

          requireField(insuranceInfo?.buyerGender, "buyerGender", errors.step2);

          requireField(insuranceInfo?.buyerPhone, "buyerPhone", errors.step2);
          insuranceInfo?.buyerPhone?.length !== 10 && errors.step2.push("buyerPhone_length");

          requireField(insuranceInfo?.buyerEmail, "buyerEmail", errors.step2);
          insuranceInfo?.buyerEmail && !regexEmail.test(insuranceInfo?.buyerEmail) && errors.step2.push("buyerEmail_length");

          requireField(insuranceInfo?.buyerAddress, "buyerAddress", errors.step2);
          minLength(insuranceInfo?.buyerAddress, 10, "buyerAddress_length", errors.step2);

          requireField(vehicleInfo?.license, "license", errors.step2);
          minLength(vehicleInfo?.license, 5, "license_length", errors.step2);

          requireField(vehicleInfo?.chassis, "chassis", errors.step2);
          minLength(vehicleInfo?.chassis, 6, "chassis_length", errors.step2);

          requireField(vehicleInfo?.engine, "engine", errors.step2);
          minLength(vehicleInfo?.engine, 6, "engine_length", errors.step2);
          break;

        case 3:
          if (!errors.step3) {
            errors.step3 = [];
          }
          if (dialogBill.open) {
            requireField(dialogBill?.address, "address_bill", errors.step3);
            requireField(dialogBill?.name, "name_bill", errors.step3);
            requireField(dialogBill?.taxCode, "taxCode_bill", errors.step3);
            requireField(/^[\d\-\/.\s]{10,}$/.test(dialogBill?.taxCode || ""), "vat_format", errors.step3);
          }

          if (haveBill === "YES") {
            if (
              !insuranceInfo.vatInfo?.address ||
              !insuranceInfo.vatInfo?.name ||
              !insuranceInfo.vatInfo?.taxCode
            ) {
              if (!errors.step3.includes("insufficient_information")) {
                errors.step3.push("insufficient_information");
              }
            }
          }

          requireField(!invalidAppliedCommissionAmt, "invalid_applied_commission_amount", errors.step3);
          break;
      }

      return { errors: { ...errors }, snackbars: { ...newSnackBars } };

    },

    checkValidProductLine: async () => {
      const { errors, currentStep, snackbars, vehicleInfo } = state;
      // console.log(vehicleInfo)
      let stepErrors = errors[`step${currentStep}`] || [];
      let newSnackBars = { ...snackbars };
      let isValidProductLine;
      if (vehicleInfo?.productLine?.id) {
        dispatch("onLoading");
        const productLineByBikeTypeRes = await getProductLineByBikeType(vehicleInfo?.productLine?.id);
        // console.log('checkedValidApiRes', productLineByBikeTypeRes.data?.data?.capacity);
        if (productLineByBikeTypeRes?.status === 200) {
          // console.log('vehicleInfo.type?.code', vehicleInfo.type);
          isValidProductLine =
            productLineByBikeTypeRes.data?.data?.capacity === vehicleInfo.type?.code;

          if (!isValidProductLine) {
            if (!stepErrors.includes("invalid_product_line")) {
              stepErrors.push("invalid_product_line");
            }
            newSnackBars = {
              open: true,
              type: "error",
              message: "Dòng xe không hợp lệ với loại xe đã chọn. Vui lòng chọn lại",
            };
          } else {
            const index = stepErrors.indexOf("invalid_product_line");
            if (index !== -1) {
              stepErrors.splice(index, 1);
            }
          }
        } else {
          newSnackBars = {
            open: true,
            type: "error",
            message: "Có lỗi xảy ra. Vui lòng thử lại",
          };
        }
        errors[`step${currentStep}`] = stepErrors;
        console.log('isValidProductLine', isValidProductLine)
      }

      return { errors: { ...errors }, snackbars: { ...newSnackBars }, loading: false, validProductLine: isValidProductLine ? true : false };
    },

    nextPage: () => {
      const { currentStep, errors } = state;
      if (errors[`step${currentStep}`]?.length > 0) {
        return {
          snackbars: {
            open: true,
            type: "error",
            message: "Vui lòng nhập đầy đủ thông tin",
          },
        };
      }
      const newCurrentStep = currentStep + 1;

      return { currentStep: newCurrentStep };
    },

    comeBackPage: () => {
      const { currentStep, vehicleInfo } = state;
      if (currentStep === 1) {
        dispatch("resetVehicleInfo")
      }
      const newCurrentStep = currentStep - 1;

      return { currentStep: newCurrentStep };
    },

    resetVehicleInfo: () => {
      const { vehicleInfo } = state;
      let newVehicleInfo = { ...vehicleInfo };
      newVehicleInfo.brand = {};
      newVehicleInfo.productLine = {}

      return { vehicleInfo: newVehicleInfo }
    },

    inital_step1: async () => {
      dispatch("onLoading");
      let configs = {};
      let snackbars = {};
      const resGetConfigs = await getConfigs();
      if (resGetConfigs?.status == 200) {
        configs = {
          vehicleTypes: resGetConfigs.data?.data?.vehicleType,
          brands: resGetConfigs.data?.data?.brands,
          yearsOfInsurance: resGetConfigs.data?.data?.yearOfInsurance
        }
      } else {
        snackbars = {
          open: true,
          type: "error",
          message: "Có lỗi xảy ra. Vui lòng thử lại",
        }
      }

      return {
        loading: false, configs: { ...configs },
        snackbars: { ...snackbars }, resultBrandsOnSearch: configs.brands
      };
    },

    openDialogBill: () => {
      const { dialogBill, insuranceInfo, haveBill } = state;
      if (haveBill === "NO") {
        return;
      }

      return {
        dialogBill: {
          ...dialogBill,
          open: true,
          ...(insuranceInfo?.vatInfo || {}),
          type: insuranceInfo?.vatInfo?.type || "PERSONAL",
          name: insuranceInfo?.buyerName
        },
      };
    },

    onChangeRadioBill: () => {
      const { value } = action;

      let { errors, currentStep } = state;
      const stepErrors = errors[`step${currentStep}`]?.filter((i) => i !== "insufficient_information");
      errors[`step${currentStep}`] = stepErrors;

      return { haveBill: value, errors };
    },

    onChangeBill: () => {
      console.log('onChangeBill');
      const { name, value } = action;
      const { dialogBill, errors, currentStep } = state;

      dialogBill[name] = value;
      const stepErrors = errors[`step${currentStep}`]?.filter((i) => name + "_bill" !== i);

      if (name === "name") {
        const newValue = capitalizeWords(value);
        dialogBill[name] = newValue;
      }

      if (name === "type") {
        dialogBill.name = "";
        dialogBill.address = "";
        dialogBill.taxCode = "";
      }

      if (dialogBill.name && dialogBill.address && dialogBill.taxCode) {
        const index = stepErrors?.indexOf("insufficient_information");
        if (index !== -1) {
          stepErrors?.splice(index, 1);
        }
        dialogBill.isReadyUpdate = true

        if (!/^[\d\-\/.\s]{10,}$/.test(dialogBill?.taxCode || "")) {
          dialogBill.isReadyUpdate = false
        }

      } else {
        dialogBill.isReadyUpdate = false
      }
      errors[`step${currentStep}`] = stepErrors;

      return { dialogBill, errors };
    },

    submitBill: () => {
      const { insuranceInfo, dialogBill, errors, currentStep } = state;
      let newErrors = errors;
      insuranceInfo.vatInfo = {
        type: dialogBill.type,
        name: dialogBill.name,
        taxCode: dialogBill.taxCode,
        address: dialogBill.address,
      };
      if (errors[`step${currentStep}`]?.includes("insufficient_information")) {
        newErrors[`step${currentStep}`] = errors[`step${currentStep}`].filter((i) => i !== "insufficient_information");
      }
      return { insuranceInfo, dialogBill: { open: false }, errors: newErrors };
    },

    closeDialogBill: () => {
      const { insuranceInfo, dialogBill } = state;

      return {
        dialogBill: {
          ...dialogBill,
          open: false,
          ...(insuranceInfo?.vatInfo || {}),
        },
      };
    },

    onChoosePackage: () => {
      const { name } = action;
      const { vehicleInfo, errors } = state;
      vehicleInfo.packageCode = name;
      const newError = errors.filter((i) => i != "packageCode");
      return { vehicleInfo, errors: [...newError] };
    },

    onChooseTypeVehicle: () => {
      const { name } = action;
      const { vehicleInfo } = state;
      vehicleInfo.packageCode = name;
      return { vehicleInfo };
    },

    openDialogInforPackage: () => {
      const { name } = action;
      const { dialogPackage } = state;

      dialogPackage.name = name;
      dialogPackage.open = true;

      return { dialogPackage };
    },

    closeDialogInforPackage: () => {
      return { dialogPackage: { open: false } };
    },

    scanImage: async () => {
      const { value, callback } = action;
      let { vehicleInfo, snackbars, insuranceInfo } = state;
      let newVehicleInfo = { ...vehicleInfo };
      let newInsuranceInfo = { ...insuranceInfo };
      try {
        const scanResult = await scanImage(value);
        if (scanResult?.status === 200) {
          newVehicleInfo = {
            ...newVehicleInfo,
            chassis: scanResult?.data?.result?.chassis,
            engine: scanResult?.data?.result?.engine,
            license: scanResult?.data?.result?.plate,
            scanedCard: scanResult?.data?.result?.image
          };
          newInsuranceInfo = {
            ...newInsuranceInfo,
            buyerAddress: scanResult?.data?.result?.address,
            buyerName: scanResult?.data?.result?.name,
            buyerGender: scanResult?.data?.result?.gender
          }
        } else {
          snackbars = {
            open: true,
            type: "error",
            message: "Có lỗi xảy ra. Vui lòng thử lại",
          };
        }
      } catch (e) {
        snackbars = {
          open: true,
          type: "error",
          message: "Có lỗi xảy ra. Vui lòng thử lại",
        };
      } finally {
        if (callback) callback();
      }

      return { vehicleInfo: newVehicleInfo, insuranceInfo: newInsuranceInfo, snackbars: { ...snackbars } };
    },

    scanImageV2: async () => {
      const { value, callback } = action;
      let { vehicleInfo, snackbars, insuranceInfo } = state;
      let newVehicleInfo = { ...vehicleInfo };
      let newInsuranceInfo = { ...insuranceInfo };
      try {
        const uploadResult = await uploadImg(value);
        if (!uploadResult?.data?.success || !uploadResult?.data?.data?.url) {
          snackbars = {
            open: true,
            type: "error",
            message: "Có lỗi xảy ra. Vui lòng thử lại",
          };
          return { snackbars: { ...snackbars } }
        }

        const dataStime = await getStime();
        if (!dataStime.data.success) {
          throw new Error("Không lấy được stime. Vui lòng thử lại");
        }

        const env = process.env.REACT_APP_NODE_ENV;
        const data = qs.stringify(sortObjectByKey({ imageUrl: uploadResult.data.data.url }));
        const uuid = uuidv4();
        const client = md5(env + "-" + data + dataStime.data.data.stime + uuid);
        const headerParam = {
          "x-api-stime": dataStime.data.data.stime,
          "x-api-nonce": uuid,
          "x-api-client": client,
        }
        const scanResult = await scanImageV2(
          {
            imageUrl: uploadResult.data.data.url
          },
          headerParam
        );

        if (scanResult?.data?.success && Object.keys(scanResult?.data?.data).length) {
          newVehicleInfo = {
            ...newVehicleInfo,
            chassis: scanResult?.data?.data?.chassis,
            engine: scanResult?.data?.data?.engine,
            license: scanResult?.data?.data?.plate,
            scanedCard: uploadResult.data.data.url
          };
          newInsuranceInfo = {
            ...newInsuranceInfo,
            buyerAddress: scanResult?.data?.data?.address,
            buyerName: scanResult?.data?.data?.name,
          }
        } else {
          snackbars = {
            open: true,
            type: "error",
            message: "Có lỗi xảy ra. Vui lòng thử lại",
          };
        }
      } catch (e) {
        snackbars = {
          open: true,
          type: "error",
          message: "Có lỗi xảy ra. Vui lòng thử lại",
        };
      } finally {
        if (callback) callback();
      }

      return { vehicleInfo: newVehicleInfo, insuranceInfo: newInsuranceInfo, snackbars: { ...snackbars } };
    },

    onChangeVelhicleInfor: async () => {
      const { name, value } = action;
      const { vehicleInfo, errors, currentStep, insuranceInfo } = state;
      // console.log('vehicle trước chọn lại', vehicleInfo)
      let stepErrors = errors[`step${currentStep}`] || [];
      const res = {};
      // console.log('insurance', insuranceInfo);
      let newVehicleInfo = { ...vehicleInfo };
      let newInsuranceInfo = { ...insuranceInfo };
      stepErrors = stepErrors?.filter(
        (i) => ![name, `${name}_length`].includes(i)
      );

      switch (name) {
        case "type":
          newVehicleInfo.type = { ...value };
          newVehicleInfo.brand = {};
          newVehicleInfo.productLine = {};
          break;

        case "brand":
          newVehicleInfo.brand = { ...value };
          newVehicleInfo.productLine = {};
          dispatch("onLoading");
          const apiGetProductLines = await getProductLines(value.id);

          if (apiGetProductLines?.status === 200) {
            const lines = get(apiGetProductLines, "data.data") || [];
            res.ProductLines = lines;
            res.resultProductLinesOnSearch = lines;
          } else {
            res.snackbars = {
              open: true,
              type: "error",
              message: "Có lỗi xảy ra. Vui lòng thử lại",
            };
          }

          res.resultBrandsOnSearch = state.configs?.brands;
          break;

        case "productLine":
          newVehicleInfo.productLine = { ...value };
          newVehicleInfo.priceForInsurance = +value.price || "";
          break;

        case "period":
          newVehicleInfo.period = value ? value.value : null;
          const from = dayjs(insuranceInfo.validFrom);
          const until = from.add(value.value ?? 1, "year").subtract(1, "day");
          newInsuranceInfo.validUntil = until.format("YYYY-MM-DD");
          break;

        case "license":
          newVehicleInfo.license = value?.toUpperCase() || "";
          if (!value) {
            stepErrors.push("license");
          } else if (value.length < 5) {
            stepErrors.push("license_length");
          }
          break;

        case "chassis":
          newVehicleInfo.chassis = value?.toUpperCase() || "";
          if (!value) {
            stepErrors.push("chassis");
          } else if (value.length < 6) {
            stepErrors.push("chassis_length");
          }
          break;

        case "engine":
          newVehicleInfo.engine = value?.toUpperCase() || "";
          if (!value) {
            stepErrors.push("engine");
          } else if (value.length < 6) {
            stepErrors.push("engine_length");
          }
          break;
      }

      errors[`step${currentStep}`] = stepErrors;

      return {
        ...state,
        ...res,
        errors,
        loading: false,
        vehicleInfo: newVehicleInfo,
        insuranceInfo: newInsuranceInfo,
      };
    },

    getPackage: async () => {
      const { vehicleInfo, errors, currentStep } = state;
      dispatch("onLoading");
      const res = {};
      res.foundPackage = {};
      res.errors = { ...errors };
      let apiGetPackages;

      if (vehicleInfo?.type?.code) {
        apiGetPackages = await getPackage({
          bikeType: vehicleInfo?.type?.code,
          period: vehicleInfo?.period,
        });
      }

      if (apiGetPackages?.status === 200) {
        res.foundPackage = get(apiGetPackages, "data.data");
        res.fessTotal = res.foundPackage.packagePrice
      } else {
        if (apiGetPackages?.data?.code === "ZUTTORIDE_PACKAGE_NOT_FOUND") {
          res.foundPackage = {}
          res.fessTotal = 0;
          res.snackbars = {
            open: true,
            type: "error",
            message: "Không tìm thấy gói dịch vụ phù hợp",
          };
        } else if (apiGetPackages) {
          res.snackbars = {
            open: true,
            type: "error",
            message: "Có lỗi xảy ra. Vui lòng thử lại",
          };
        }
      }

      return { loading: false, ...res };
    },

    onSearchBike: () => {
      const { name, key } = action;
      const brands = state.configs.brands;
      const ProductLines = state.ProductLines;
      const res = {};
      const newKey = removeUnicode(key).toLowerCase();
      if (name === "brand") {
        res.resultBrandsOnSearch = newKey
          ? [
            ...brands.filter((i) => {
              return removeUnicode(i.title).toLowerCase().includes(newKey);
            }),
          ]
          : [...brands];
      }

      if (name === "productLine") {
        res.resultProductLinesOnSearch = newKey
          ? [
            ...ProductLines.filter((i) => {
              return removeUnicode(i.title).toLowerCase().includes(newKey);
            }),
          ]
          : [...ProductLines];
      }

      return { ...res };

    },

    onChangeSlider: () => {
      const { value } = action;
      const { percentOfCarPrice, vehicleInfo, errors } = state;

      if (isEmpty(vehicleInfo.motorbike) || !vehicleInfo?.motorbike?.price) {
        !vehicleInfo?.vehicleType?.id && errors.push("vehicleType");
        !vehicleInfo?.manufacture?.uid && errors.push("manufacture");
        !vehicleInfo?.motorbike?.uid && errors.push("motorbike");
        !vehicleInfo?.yearOfFirstRegistration &&
          errors.push("yearOfFirstRegistration");
        return {
          snackbars: {
            open: true,
            type: "error",
            message: "Vui lòng nhập thông tin xe !!!",
          },
        };
      }

      percentOfCarPrice.percent = value;
      percentOfCarPrice.curent =
        (+vehicleInfo?.motorbike?.price || 0) +
        (value * (+vehicleInfo?.motorbike?.price || 0)) / 100;

      vehicleInfo.priceForInsurance =
        (+vehicleInfo?.motorbike?.price || 0) +
        (value * (+vehicleInfo?.motorbike?.price || 0)) / 100;

      return { percentOfCarPrice, vehicleInfo, errors };
    },

    onChangeBeginDate: () => {
      const { newValue } = action;
      console.log('value', newValue)
      const { vehicleInfo, insuranceInfo } = state;

      insuranceInfo.validFrom = dayjs(newValue).format("YYYY-MM-DD");
      insuranceInfo.validUntil = dayjs(newValue)
        .add(+vehicleInfo?.period || 1, "year")
        .add(-1, "day")
        .format("YYYY-MM-DD");

      return { insuranceInfo };
    },

    onChangeInsuranceInfo: () => {
      const { name, value } = action;
      const { insuranceInfo, errors, currentStep } = state;
      const newInsuranceInfo = { ...insuranceInfo };
      let stepErrors = errors[`step${currentStep}`] || [];
      stepErrors = stepErrors.filter((i) => ![name, `${name}_length`].includes(i));

      newInsuranceInfo[name] = value;

      if (name === "buyerName") {
        newInsuranceInfo.buyerName = capitalizeWords(value);
        if (newInsuranceInfo.buyerName && newInsuranceInfo.buyerName.length < 5) {
          stepErrors.push("buyerName_length");
        }
      }

      if (name === "buyerPhone") {
        if (newInsuranceInfo.buyerPhone && newInsuranceInfo.buyerPhone.length !== 10) {
          stepErrors.push("buyerPhone_length");
        }
      }

      if (name === "buyerAddress") {
        if (newInsuranceInfo.buyerAddress && newInsuranceInfo.buyerAddress.length < 10) {
          stepErrors.push("buyerAddress_length");
        }
      }

      if (name === "buyerEmail") {
        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (newInsuranceInfo.buyerEmail && !regexEmail.test(newInsuranceInfo.buyerEmail)) {
          stepErrors.push("buyerEmail_length");
        }
      }

      errors[`step${currentStep}`] = stepErrors;

      return { insuranceInfo: newInsuranceInfo, errors };
    },

    init_step3: async () => {
      const { vehicleInfo, foundPackage } = state;
      dispatch("onLoading");

      let fessTotal = foundPackage.packagePrice || 0;

      const params = {
        productCode: "zuttoride",
        pbpCode: "chxm_zr",
        vehicleInfo: {
          vehicleType: vehicleInfo?.type,
          yearsOfInsurance: vehicleInfo?.period
        },
      };
      const res = {};

      if (!reward && (isApp || isZalo_mini)) {
        if (params.vehicleInfo?.vehicleType?.vehicleType) {
          delete params.vehicleInfo.vehicleType.vehicleType
        }

        const apiCommission = await getCommission(params);
        if (apiCommission?.data?.success) {
          res.commission = apiCommission?.data?.data;
        }
      }

      if (reward) {
        const apiBalance = await getBalance();
        if (apiBalance?.data?.statusCode === 200) {
          res.balance = +apiBalance?.data?.result?.wallet?.balance;
        }
      }
      return { fessTotal, loading: false, ...res };
    },

    onChangeRedeemCode: () => {
      const { value } = action;
      const { redeemCode } = state;
      redeemCode.codeLocal = value;
      return { redeemCode };
    },

    apllyRedeemConde: async () => {
      const { redeemCode, vehicleInfo } = state;

      if (!redeemCode.codeLocal) {
        return {
          snackbars: {
            open: true,
            type: "error",
            message: "Vui lòng nhập mã ưu đãi",
          },
        };
      }
      dispatch("onLoading");
      const newVehicleInfo = { ...vehicleInfo };
      const prams = {
        pbpId: 120,
        redeemCode: redeemCode.codeLocal,
        vehicleInfo: {
          vehicleType: {
            id: newVehicleInfo.type.id,
            code: newVehicleInfo.type.code,
            title: newVehicleInfo.type.title
          },
          yearsOfInsurance: +newVehicleInfo.yearsOfInsurance
        }
      }
      // {
      //   pbpId: 120,
      //   redeemCode: redeemCode.codeLocal,
      //   vehicleInfo: {
      //     ...newVehicleInfo
      //   },
      // };
      const apiRedeem = await checkRedeemCode(prams);

      const res = {};
      if (apiRedeem?.data?.success) {
        const dataApi = apiRedeem?.data?.data || {};
        res.redeemCode = { ...redeemCode, ...dataApi };
      } else {
        res.redeemCode = {};
        res.snackbars = {
          open: true,
          type: "error",
          message: "Mã ưu đãi không hợp lệ. Vui lòng thử lại",
        }
      }

      return { loading: false, ...res };
    },

    editPage: () => {
      const { name } = action;
      if (name === "insurance") return { currentStep: 2 };
      if (name === "inforUser") return { currentStep: 2 };
      if (name === "inforVehical") return { currentStep: 1 };
    },

    onCheckCamKet: () => {
      const { value, name } = action;
      const { cam_ket } = state;
      cam_ket[name] = value;

      return { cam_ket };
    },

    onChangeAppliedCommissionAmount: () => {
      const { value, maxValue } = action;
      return { appliedCommissionAmount: value, invalidAppliedCommissionAmt: value > maxValue };
    },

    createInsu: async () => {
      const {
        cam_ket,
        vehicleInfo,
        insuranceInfo,
        redeemCode,
        haveBill,
        errors,
        currentStep,
        foundPackage,
        appliedCommissionAmount
      } = state;

      if (!haveBill) {
        return {
          snackbars: {
            open: true,
            type: "error",
            message: "Vui lòng chọn thông tin xuất hoá đơn",
          },
        }
      }

      if (errors[`step${currentStep}`]?.includes("insufficient_information")) {
        return {
          snackbars: {
            open: true,
            type: "error",
            message: "Vui lòng nhập đầy đủ thông tin xuất hóa đơn",
          },
        };
      }

      if (!cam_ket.da_doc || !cam_ket.dung_noi_dung || !cam_ket.tinh_trang_xe) {
        return {
          snackbars: {
            open: true,
            type: "error",
            message: "Vui lòng đọc và cam kết điều kiện điều khoản, chính sách để tiếp tục!",
          },
        };
      }

      if (vehicleInfo.vehicleType?.vehicleType) {
        delete vehicleInfo.vehicleType.vehicleType
      }

      if (errors[`step${currentStep}`].length > 0) {
        return
      }

      dispatch("onLoading");
      const rewards = reward ? { reward: 'YES' } : { reward: 'NO' };
      const vatInfo = haveBill === "YES" ? { ...insuranceInfo?.vatInfo } : null;
      const optionalPartner = getParamUrlByKey("optional_partner");
      const partnerStaffId = getParamUrlByKey("staff_id");
      const callBackUrl = getParamUrlByKey("callback_url") || "";
      const params = {
        platform: platform || "web",
        isPayLater: "NO",
        productId: 57,
        providerId: 19,
        pbpId: 120,
        redeemCode: redeemCode?.discountCode || undefined,
        callbackUrl: callBackUrl || window.location.href,
        ...rewards,
        vehicleInfo: {
          vehicleType: vehicleInfo?.type,
          manufacture: vehicleInfo?.brand,
          motorbike: vehicleInfo?.productLine,
          license: vehicleInfo?.license,
          chassis: vehicleInfo?.chassis,
          engine: vehicleInfo?.engine,
          yearsOfInsurance: vehicleInfo?.period,
          yearOfFirstRegistration: moment(insuranceInfo.validFrom, "YYYY-MM-DD").year(),
          priceForInsurance: foundPackage?.packagePrice,
          imgCavet: vehicleInfo?.scanedCard || null
        },
        insuranceInfo: {
          ...insuranceInfo,
          vatInfo,
          ...(optionalPartner ? { optionalPartner } : {}),
          ...(partnerStaffId ? { partnerStaffId } : {}),
        },
        ...(appliedCommissionAmount ? { appliedCommissionAmount } : {})
      };
      // console.log('create params', params, appliedCommissionAmount);
      // return
      const apiCreate = await createInsu(params);
      const res = {};

      if (apiCreate?.data?.success) {
        res.orders = get(apiCreate, "data.data") || {};
        dispatch("openDialogSuccess");
      } else {
        let message;

        switch (apiCreate?.data?.code) {
          case "ZUTTORIDE_INVALID_VALID_FROM_VALID_UNTIL":
            message = "Ngày hiệu lực và kết thúc của dịch vụ không hợp lệ.";
            break;

          default:
            message = "Có lỗi xảy ra, vui lòng thử lại.";
        }

        res.snackbars = {
          open: true,
          type: "error",
          message,
        };
      }

      return { loading: false, ...res };
    },

    payOrder: () => {
      const { orders } = state;

      // if (!orders.paymentUrl) return;
      if (platform == "app") {
        window.ReactNativeWebView?.postMessage("gotocart");
      } else {
        window.location.replace(orders.paymentUrl);
      }
      dispatch("closeDialogSuccess");
    },

    openDialogSuccess: () => {
      return { dialogSuccess: { open: true } };
    },

    closeDialogSuccess: () => {
      return { dialogSuccess: { open: false } };
    },

    closeSnackbar: () => ({ snackbars: {} }),

    onLoading: () => ({ loading: true }),
  };
  return cases[action?.type];
}
